<template>
	<div class="mb-4">
		<input
			id="file"
			class="inputfile"
			type="file"
			accept=".png, .jpg, .jpeg "
			@change="img_upload"
		/>
		<label for="file">{{ $t('select_image') }}</label>
		<button
			class="
				bg-secondary
				text-white
				border-0
				rounded-sm
				p-2
				mt-2
				shadow-md
				outline-none
				cursor-pointer
				hover:text-primary
				focus:outline-none
			"
			@click.prevent="img_reset"
		>
			{{ $t('delete_image') }}
		</button>
	</div>
</template>

<script>
export default {
	props: {
		image: File
	},
	methods: {
		img_reset() {
			this.$emit('reset-image')
		},
		img_upload(event) {
			const image = event.target.files[0]
			this.$emit('upload-image', image)
		}
	}
}
</script>

<style>
.inputfile {
	width: 0.1px;
	height: 0.1px;
	opacity: 0;
	overflow: hidden;
	position: absolute;
	z-index: -1;
}
.inputfile + label {
	color: white;
	display: inline-block;
	padding: 0.5rem;
	border-radius: 0.125rem;
	margin-right: 15px;
	margin-left: 0;
}
.inputfile + label:hover {
	color: #68ace1;
	cursor: pointer;
}
</style>
